// import Cookies from "js-cookie";

const payment = {
  state: {
    payments: []
  },
  mutations: {
    SET_PAYMENT(state, payload) {
      state.payments = payload;
    },
    RESET_DATA(state) {
      state.payments = [];
    }
  }
};

export default payment;
